'use strict';


module.exports = {
    init: function () {
        var index = 0,
            $nodes;

        if ( MODE === 'MINISTRA' ) {
            $nodes = document.getElementsByClassName('app-icon');

            if ( $nodes[index] ) {
                // stop animation without abrupt interruption
                while ( index <= 3 ) {
                    $nodes[index].classList.remove('animated');
                    index++;
                }
            }
        }

        if ( !NANOCORE ) {
            // window.splash.className = 'container';
            window.splashAppVersion.innerText = '';
            if ( window.loader && document.getElementById('loader') && document.getElementById('loader').parentElement ) {
                // remove loader
                document.body.removeChild(document.getElementById('loader'));
            }
        }
    },
    show: function ( config ) {
        window.splash.style.backgroundImage = 'url(' + config.uris.icons.logoActive + ')';
        window.splash.style.backgroundColor = config.colors.splashBackground;
        window.splash.style.zIndex = '9999';
        window.splashAppName.innerText = config.name;
        window.splashAppName.style.color = config.colors.splashFont;
        window.splashAppVersion.innerText = config.version;
        // show splash
        window.splash.classList.remove('invisible');
        this.active = true;
    },
    hide: function () {
        // hide splash
        window.splash.className = 'container invisible';
        window.splash.removeAttribute('style');
        this.active = false;
    },
    active: false
};
